module.exports = __webpack_public_path__ + "img/dfn-cert-logo.66fc2c90.svg";